// ClassList.js

import React from "react";

const ClassList = ({ classes, onViewClass }) => (
  <div className="class-list">
    <ul>
      {classes.map((cls, index) => (
        <li key={index}>
          <span>{cls.className}</span>
          <span>{cls.totalStudents || 0} Students</span>
          <button className="view-btn" onClick={() => onViewClass(cls)}>
            View Details
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export default ClassList;
